import React from 'react';
import './Home.css';
import Me from '../../assets/mypic/atik.png';
import HeaderSocials from './HeaderSocials';
import ScrollDown from './ScrollDown';
import Shapes from './Shapes';

const Home = () => {
    return (
        <section className="home container" id='home'>
            <div className="intro">
                <img src={Me} alt="Atikur Rahman" className='home__img' width='160' />
                <h1 className="home__name">Atikur Rahman</h1>
                <span className="home__education">Aspiring Software Engineer | AI & ML Enthusiast</span>

                <div className="home__socials-wrapper">
                    <HeaderSocials />
                </div>

                <a href="#contact" className="btn"> Contact Me</a>

                <ScrollDown />
            </div>

            <Shapes />
        </section>
    )
}

export default Home;
